import { FormErrors } from 'redux-form'
import { IFormValues } from './index'

export default function(): FormErrors<IFormValues, string> {
  return {}
}
